import { Theme } from '@emotion/react';
import { baseTheme } from './base-theme';

export const sleepioTheme: Theme = {
  ...baseTheme,
  name: 'Sleepio Theme',
};
